import { useMutation } from '@tanstack/react-query';

export function useUpdateBusinessSettingsMutation() {
  return useMutation({
    mutationFn: async ({ data }) => {
      const response = await axios.patch('/settings/business', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    },
  });
}
